export default [{
  value: 'enrollment',
  text: 'Matrícula'
}, {
  value: 'fee',
  text: 'Cuota'
}, {
  value: 'custom',
  text: 'Personalizado'
}]



// WEBPACK FOOTER //
// ./src/data/paymentTypes.js